export const text = () => (
  <path
    d="M4 7V4h16v3M9 20h6M12 4v16"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
